import { combineReducers } from "redux";

import upcomingEvents from "../events/reducers/events";
import latestStories from "./latestStories";
import navigation from "./navigation";
import newsletters from "../subscriptions/reducers/newsletters";
import storiesStream from "./storiesStream";
import subscriptions from "../subscriptions/reducers/subscriptions";
import trending from "./trending";
import search from "./search";

export default combineReducers({
  upcomingEvents,
  latestStories,
  navigation,
  newsletters,
  search,
  storiesStream,
  subscriptions,
  trending,
});
